import { Card, Typography, Box, Divider } from '@mui/joy'
import noAvatarImage from 'assets/images/no-avatar.png'
import { chatApiList } from 'components/ChatApisPreview/ChatApisPreview'
import dayjs from 'dayjs'
import MessageMedia from 'elements/MessageView/MessageMedia'
import { OBJECT_TYPES } from 'utils/constants'

type Props = {
    item: any
}

const MessageListItem = ({ item }: Props) => {
    const sourceItem = chatApiList.find((el) => el.key === item.source)

    const contentItem =
        OBJECT_TYPES.find((type: any) => type.id === item.contentType) ?? null

    return (
        <Card
            sx={{
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'start',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        gap: 1,
                    }}
                >
                    <Typography
                        level="body-xs"
                        sx={(theme) => ({
                            color: 'white',
                            [theme.getColorSchemeSelector('light')]: {
                                color: '#171A1C',
                            },
                        })}
                    >
                        {item.authorName}
                    </Typography>

                    <Divider
                        orientation="vertical"
                        sx={(theme) => ({
                            background: 'white',
                            width: '1px',
                            [theme.getColorSchemeSelector('light')]: {
                                background: '#171A1C',
                            },
                        })}
                    />
                    <Box>
                        <Typography
                            level="body-xs"
                            sx={(theme) => ({
                                color: 'white',
                                [theme.getColorSchemeSelector('light')]: {
                                    color: '#171A1C',
                                },
                            })}
                        >
                            {dayjs(item.timestamp * 1000).format(
                                'DD.MM.YYYY HH:mm'
                            )}
                        </Typography>
                    </Box>
                    <Divider
                        orientation="vertical"
                        sx={(theme) => ({
                            background: 'white',
                            width: '1px',
                            [theme.getColorSchemeSelector('light')]: {
                                background: '#171A1C',
                            },
                        })}
                    />
                    <Box
                        sx={{
                            display: 'flex',
                            gap: 1,
                        }}
                    >
                        {sourceItem && (
                            <img
                                src={sourceItem.icon}
                                alt={sourceItem.label}
                                width={16}
                                height={16}
                                style={{
                                    borderRadius: 4,
                                }}
                            />
                        )}

                        <Typography
                            level="body-xs"
                            sx={(theme) => ({
                                color: 'white',
                                [theme.getColorSchemeSelector('light')]: {
                                    color: '#171A1C',
                                },
                            })}
                        >
                            {item.source}
                        </Typography>
                    </Box>
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        gap: 2,
                    }}
                >
                    <Typography
                        level="body-sm"
                        sx={(theme) => ({
                            color: 'white',
                            [theme.getColorSchemeSelector('light')]: {
                                color: '#171A1C',
                            },
                        })}
                    >
                        {contentItem?.name}
                    </Typography>
                    <Typography
                        level="body-sm"
                        sx={(theme) => ({
                            color: 'white',
                            [theme.getColorSchemeSelector('light')]: {
                                color: '#171A1C',
                            },
                        })}
                    >
                        ID:{item.id}
                    </Typography>
                </Box>
            </Box>

            <Box
                sx={{
                    display: 'flex',
                    gap: 2,
                }}
            >
                <Box
                    sx={{
                        background: '#ccc',
                        width: '60px',
                        height: '60px',
                    }}
                >
                    <img
                        src={noAvatarImage}
                        style={{
                            objectFit: 'cover',
                            padding: '4px',
                            maxWidth: '60px',
                            maxHeight: '60px',
                        }}
                        alt="Pavuk AI App"
                    />
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 1,
                        overflowWrap: 'break-word',
                    }}
                >
                    {/* <Typography level="body-lg" sx={{ color: '#006EEE' }}>
                        {item.title}
                    </Typography> */}
                    <Typography
                        level="body-md"
                        sx={{
                            overflowWrap: 'break-word',
                            maxWidth: '100%',
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-all',
                        }}
                    >
                        {item.text}
                    </Typography>
                    {item.attachmentUrls ? (
                        <MessageMedia
                            messageItem={item}
                            messageId={item.id}
                            olrsBasicData={null}
                            // viewLimit={
                            //     viewMode.includes('compact-dsc-content') ? 1 : 5
                            // }
                            viewLimit={5}
                            // highlightWords={{
                            //     ...topicKeywords,
                            //     smartBarKeywords: smartbarFilters
                            //         ? smartbarFilters.map((el: any) => el.name)
                            //         : [],
                            // }}
                        />
                    ) : null}
                    {/* {item.attachmentUrls
                        ? item.attachmentUrls.map((el: string) => (
                              <img src={el} />
                          ))
                        : null} */}
                </Box>
            </Box>
        </Card>
    )
}

export default MessageListItem
